const alert = require('base/components/errorNotification');

/**
 * Init globally reusable modals for content links
 *
 * The function adds an event listener on the ".modal-link" class in a button element.
 *
 * Required Attributes:
 * data-link=”contentAssetURL” - This will be the Page Link to the Content Asset or Partial Page.
 *
 */

/**
 * Gets the modal content
 * @param {string} url - the get url
 * @param {string} pageSelector - the partial page container to use in the response html
 * @returns {Promise} - a promise resolved with the modal content
 */
function getModalContent(url, pageSelector) {
    var selectorString = pageSelector || '.content-asset-container';
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            success: (html) => {
                var $content = $(html).find(selectorString);
                if ($content.length === 0) {
                    $content = $(html).clone();
                }

                $content.removeClass('container');
                resolve($content.html());
            },
            error: (err) => reject(err)
        });
    });
}

/**
 * Creates the modal jQuery element
 * @param {string} title - the modal's title content
 * @param {string} body - the modal's body content
 * @param {Object} options - display options
 * @returns {jQuery} - a modal
 */
function createModalElement(title, body, options) {
    var closeText = $('.modal-background').data('close');
    var html =
    `
    <div class="modal fade ${options.modalClass || ''}" tabindex="-1" role="dialog">
        <div class="modal-dialog ${options.modalSize} modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class=${(!title || !options.displayTitle) ? 'd-none' : ''}><h3 class="modal-title">${title}</h3></div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="${closeText}">
                        <span aria-hidden="true" class="content-modal-close"></span>
                    </button>
                </div>
                <div class="modal-body">${body || ''}</div>
                <div class="modal-footer ${(!options.displayFooter) ? 'd-none' : ''}">
                    <button class="btn btn-primary close-btn" data-dismiss="modal">${closeText}</button>
                </div>
            </div>
        </div>
    </div>
    `;

    return $(html);
}

/**
 * @param {Object} $modal - the active modal
 * handles poster image events
 */
function initPosterImgEvents($modal) {
    var videoUtils = require('../util/videos');
    // hide the poster image to reveal the inline video
    let $videoComponent = $modal.find('.video-component');
    var $posterImg = $videoComponent.find('.poster-img');
    $posterImg.on('click', function () {
        $posterImg.addClass('disable-poster-image');
        $videoComponent.removeClass('showButton');
        videoUtils.playPauseVideo($modal, 'play');
    });
}


module.exports = function () {
    $('body').on('click', '.modal-link', (e) => {
        e.preventDefault();
        var $link = $(e.currentTarget);
        var getUrl = $link.data('link');
        var title = $link.data('title') || '';
        var displayTitle = ($link.data('display-title') !== undefined) ? $link.data('display-title') : true;
        var displayFooter = ($link.data('display-footer') !== undefined) ? $link.data('display-footer') : true;
        var pageSelector = ($link.data('cid') !== undefined) ? '.' + $link.data('cid') : null;
        var modalSize = ($link.data('size') !== undefined) ? $link.data('size') : 'modal-lg';

        $.spinner().start();
        getModalContent(getUrl, pageSelector)
        .then((content) => {
            var displayOptions = {
                displayTitle,
                displayFooter,
                modalSize
            };
            var $modal = createModalElement(title, content, displayOptions);
            $('body').append($modal);
            $modal.on('show.bs.modal', function () { $modal.focus(); });
            $modal.on('shown.bs.modal', function () {
                $('.modal-header').trigger('focus');
            });
            $modal.on('hidden.bs.modal', function () {
                $link.trigger('focus');
                $modal.remove();
            });
            $modal.modal('show');
        }).catch(function (err) {
            window.console.error(err);
            alert($('.error-messaging'), $('.error-messaging').data('default-message'));
        })
        .finally(function () {
            $.spinner().stop();
        });
    });

    // global modal events
    $('.modal').on('show.bs.modal', function () {
        $(this).focus();
    }).on('shown.bs.modal', function () {
        $(this).find('.modal-header').trigger('focus');
    }).on('hidden.bs.modal', function (e) {
        $(e.currentTarget).trigger('focus');
    });

    $('body').on('click', '.video-modal-link, .text-video-link ', (e) => {
        e.preventDefault();
        var $link = $(e.currentTarget);
        $.spinner().start();
        var $modal = $('#' + $link.data('target'));
        // append modal to the body so it works from absolutely positioned component regions
        $modal.appendTo('body').modal('show');
        $modal.on('shown.bs.modal', function () {
            $('.modal-header').trigger('focus');
            if ($modal.find('.poster-img').length > 0) {
                initPosterImgEvents($modal);
            }
        });
        $.spinner().stop();
    });
};
